/** Deal group identifiers as stored in the database */
export enum EnumDealGroupId {
  CCaaS = 'e8020c3e-4339-4c7c-a969-525d01b5d106',
  Fao = '8c36243d-e2d5-431c-93e9-533aedb0992a',
  ItLaborRates = '43327bbb-c31a-4f44-ba59-7c2ad5f2a3f9',
  ItServices = '32ae4432-7dad-4e18-9fe8-c87953ca3ed5',
  Procurement = '7c6ce53d-0848-4246-9778-d2b08b7eb51f',
  Telecom = '2d45deb9-12f6-48af-a50c-e43bd9db7764'
}

export namespace EnumDealGroupId {

  /** Resolves a raw id to an enum member, case-insensitively */
  export function fromString(value: string | null | undefined): EnumDealGroupId | null {

    if (value == null) {

      return null;
    }

    const lower = value.toLowerCase();
    const match = Object.values(EnumDealGroupId)
      .filter((id): id is EnumDealGroupId => typeof id === 'string')
      .find(id => id === lower);

    return match ?? null;
  }
}
